import type Comparables from '../models/Comparables';
import type Address from '../models/Address';

const MAP_MARKERS = {
  home: 'https://nodes3cdn.hotpads.com/google-maps-icons/MapMarker_home.png',
  active: 'https://nodes3cdn.hotpads.com/google-maps-icons/MapMarker_active.png',
  inactive: 'https://nodes3cdn.hotpads.com/google-maps-icons/MapMarker_inactive.png',
};

function _getMarkerLocations(comps: Array<Comparables>): string {
  return comps.map((comp) => `${comp.lat},${comp.lon}`).join('|');
}

export function getStaticMapUrl(listing: Address, comps: Array<Comparables>): string {
  const activeComps = comps.filter((comp) => comp.isActive && !comp.isUsersComp);
  const inactiveComps = comps.filter((comp) => !comp.isActive && !comp.isUsersComp);
  const params = new URLSearchParams({
    center: `${listing.lat},${listing.lon}`,
    size: '640x200',
    style: 'feature:poi|visibility:off',
  });
  params.append('markers', `icon:${MAP_MARKERS.home}|${listing.lat},${listing.lon}`);
  params.append('markers', `icon:${MAP_MARKERS.active}|${_getMarkerLocations(activeComps)}`);
  params.append('markers', `icon:${MAP_MARKERS.inactive}|${_getMarkerLocations(inactiveComps)}`);

  return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
}
